import React, { Component } from 'react'
import { md, Node } from 'djedi-react'
import { connect } from 'react-redux'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import Page from 'layouts/Page'
import Container from 'layouts/Container'
import Link from 'components/Link'

import PropTypes from 'prop-types'
import { NAME } from './constants'
import reducer from './reducer'
import saga from './sagas'
import selector from './selectors'
import reduxActions from './actions'

import styles from './styles.css'
import Distribute from '../../layouts/Distribute'
import Box, { BoxSection } from '../../layouts/Box'
import { NAME as ROUTE_FIND } from '../FindActivity/constants'
import { reverse } from '../../utilities/routes'
import Spinner from '../../components/Spinner'

class ListTopicsAndSchools extends Component {

  // Properties and state seem to me same with redux
  // See state vars in reducer.js
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    topics: PropTypes.arrayOf(PropTypes.object),
    schools: PropTypes.arrayOf(PropTypes.object),
    initialized: PropTypes.bool,
  }

  componentDidMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
    this.props.dispatch(reduxActions.initialize())
  }

  componentWillUnmount() {
    removeReducer(NAME)
    removeSaga(NAME)
  }

  render() {

    const { topics, schools, initialized} = this.props

    if (!initialized) {
      return <Spinner width="45" height="45" center/>
    }

    topics.sort((a, b) => a.name.localeCompare(b.name));
    schools.sort((a, b) => a.name.localeCompare(b.name));

    const topicLinks = topics.map(topic => (
      <Link
        key={topic.id}
        label={topic.name}
        className={styles.link}
        href={reverse(ROUTE_FIND, { query: { tag: topic.name } })}
      />
    ))
    const schoolLinks = schools.map(school => (
      <Link
        key={school.id}
        label={school.name}
        className={styles.link}
        href={reverse(ROUTE_FIND, { query: { tag: school.name } })}
      />
    ))

    return (
      <Page
        // {...this.props.meta.toJS()}
        className={styles.root}
        title="Aktiviteter och skolor"
        key="page"
      >
        <div className={styles.boxes}>
          <Container size="medium">
            <Distribute>
              <Box shadow>

                <BoxSection>
                  <Node uri="activities_and_schools/activities_title.md">
                    {md`
                      ###Aktiviteter

                      Aktiviteter som erbjuds
                    `}
                  </Node>
                </BoxSection>

                <BoxSection>
                  {topicLinks}
                </BoxSection>

              </Box>

              <Box shadow>

                <BoxSection>
                  <Node uri="activities_and_schools/schools_title.md">
                    {md`
                      ###Skolor

                      På följande skolor erbjuds aktiviteter
                      `}
                  </Node>
                </BoxSection>

                <BoxSection>
                  {schoolLinks}
                </BoxSection>

              </Box>


            </Distribute>


          </Container>

        </div>
      </Page>
    )
  }
}

export default connect(selector)(ListTopicsAndSchools)



// WEBPACK FOOTER //
// ../source/views/ActivitiesAndSchools/index.js